import { initMobileMenu } from './menu';
import { initMobileDropdown } from './mobile-dropdown';
import { initSwipers } from './swiper';
import { initStickyHeader } from './sticky-header';
import { initNavTabs } from "./nav-tabs"
import { initPricing } from "./pricing"
import { initVideoModal } from "./video-modal";
import { initContactForm } from './contact-form';
import { initCommentForm } from './comment-form';
import { initAccordion } from "./accordion";
import { initTawk } from "./tawk"
import { initRecaptchaLazyLoad } from "./recaptcha"
import { initConsentMap } from "./consent-map"

/* Footer <details>: open on desktop, closed on mobile */
function initFooterCollapse() {
    var details = document.querySelectorAll('.footer__col-collapse');
    if (!details.length) return;
    var mq = window.matchMedia('(min-width: 768px)');
    function apply(desktop) {
        details.forEach(function(d) {
            if (desktop) d.setAttribute('open', '');
            else d.removeAttribute('open');
        });
    }
    apply(mq.matches);
    mq.addEventListener('change', function(e) { apply(e.matches); });

    /* Prevent summary click from toggling on desktop */
    details.forEach(function(d) {
        var summary = d.querySelector('summary');
        if (!summary) return;
        summary.addEventListener('click', function(e) {
            if (mq.matches) e.preventDefault();
        });
    });
}
initFooterCollapse();

window.addEventListener('load', () => {
    const deferHeavy = () => {
        initStickyHeader();
        initMobileMenu();
        initMobileDropdown();
        initVideoModal();
        initNavTabs();
        initPricing();
        initContactForm();
        initCommentForm();
        initAccordion();
        initTawk();
        initSwipers();
        initRecaptchaLazyLoad();
        initConsentMap();
    };

    if ('requestIdleCallback' in window) {
        requestIdleCallback(deferHeavy);
    } else {
        setTimeout(deferHeavy, 200);
    }
});